/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Example_PromptsInputs */



/**
* | output |
* | --- |
* | "Examples" |
*
* @param {Assistant_Example_PromptsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_example_prompts = /** @type {((inputs?: Assistant_Example_PromptsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Example_PromptsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exemples")
	if (locale === "de") return /** @type {LocalizedString} */ ("Beispiele")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esempi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Примеры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ejemplos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("示例")
	if (locale === "ja") return /** @type {LocalizedString} */ ("例")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उदाहरण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exemplos")
	return /** @type {LocalizedString} */ ("Examples")
});